import React from 'react';
import { NavLink, NavLinkProps } from 'react-bootstrap';
import { useHistory } from 'react-router';

interface LinkProps extends NavLinkProps {}

export const Link: React.FC<LinkProps> = (props) => {
    const history = useHistory();

    const navigate = (event: any) => {
        event?.preventDefault();
        if (props.href) history.push(props.href);
    };

    return <NavLink {...props} onClick={navigate} />;
};
